export enum IconTypes {
    BOX_ICON='BOX_ICON'
}

export enum IconNames {
    SENT="sent",
    RECEIVED="received"
}